<div content class="flex flex-col gap-5">
    @if (!itemId) {
        <app-alert
            label="translate_evaluation_alert_info_title"
            description="translate_evaluation_alert_info_description"
            mode="info"
        ></app-alert>
    }
    @if (!itemId && evaluations.length > 0) {
        <div
            class="overflow-hidden rounded-[28px] border border-slate-200 bg-white"
        >
            <div
                class="border-b border-slate-200 bg-gradient-to-r from-teal-900 via-teal-800 to-cyan-800 px-5 py-5 text-white"
            >
                <p
                    class="text-xs font-semibold uppercase tracking-[0.28em] text-white/70"
                >
                    {{ 'translate_rubric_evaluation' | translate }}
                </p>
                <h3 class="mt-2 text-2xl font-bold">
                    {{ 'translate_choose_evaluation_definition' | translate }}
                </h3>
            </div>
            <div class="p-5">
                <label class="mb-2 block text-sm font-semibold text-slate-700">
                    {{ 'translate_select_the_evaluation' | translate }}
                </label>
                <ng-select
                    [items]="evaluations"
                    [ngModel]="selectedEvaluation"
                    (ngModelChange)="setSelectedEvaluation($event)"
                    bindLabel="name"
                    [clearable]="false"
                ></ng-select>
            </div>
        </div>
    }
    @if (!itemId && hasNoEvaluationDefinition) {
        <app-items-are-unavailable></app-items-are-unavailable>
    }
    @if (!hasNoEvaluationDefinition) {
        <app-list-loading [items]="$safeNavigationMigration(item?.records)">
            @if (isLoadingDefinition) {
                <div
                    class="flex min-h-[200px] items-center justify-center rounded-[28px] border border-slate-200 bg-white"
                >
                    <app-loading-ring></app-loading-ring>
                </div>
            }
            @if (!isLoadingDefinition) {
                <div class="flex flex-col gap-5">
                    @for (
                        matrix of groupedMatrices;
                        track trackByIndex($index, matrix)
                    ) {
                        <div
                            class="overflow-hidden rounded-[30px] border border-slate-200 bg-white"
                        >
                            <div
                                class="flex flex-col gap-3 border-b border-slate-200 bg-gradient-to-r from-slate-900 via-slate-800 to-teal-800 px-5 py-5 text-white md:flex-row md:items-end md:justify-between"
                            >
                                <div>
                                    <p
                                        class="text-xs font-semibold uppercase tracking-[0.28em] text-white/65"
                                    >
                                        {{
                                            'translate_group_weight' | translate
                                        }}
                                    </p>
                                    <h3 class="mt-2 text-2xl font-bold">
                                        {{ matrix.name }}
                                    </h3>
                                </div>
                                <div class="flex gap-3">
                                    <div
                                        class="rounded-2xl bg-white/10 px-4 py-3 text-center"
                                    >
                                        <div class="text-xs text-white/65">
                                            {{
                                                'translate_group_weight'
                                                    | translate
                                            }}
                                        </div>
                                        <div class="mt-1 text-xl font-bold">
                                            {{ matrix.weight ?? 0 }}%
                                        </div>
                                    </div>
                                    <div
                                        class="rounded-2xl bg-white/10 px-4 py-3 text-center"
                                    >
                                        <div class="text-xs text-white/65">
                                            {{
                                                'translate_average_of_criteria'
                                                    | translate
                                            }}
                                        </div>
                                        <div class="mt-1 text-xl font-bold">
                                            {{ getCriteriaCount(matrix) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col gap-4 p-5">
                                @for (
                                    standard of matrix.standards;
                                    track trackByIndex($index, standard)
                                ) {
                                    @if (
                                        getRecordForStandard(standard);
                                        as record
                                    ) {
                                        <section
                                            class="rounded-[24px] border border-slate-200 bg-slate-50 p-4"
                                        >
                                            <div
                                                class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between"
                                            >
                                                <div
                                                    class="flex max-w-2xl flex-col gap-3"
                                                >
                                                    <div>
                                                        <div
                                                            class="text-xs font-semibold uppercase tracking-[0.24em] text-teal-700"
                                                        >
                                                            {{
                                                                'translate_rubric_criterion'
                                                                    | translate
                                                            }}
                                                        </div>
                                                        <h4
                                                            class="mt-2 text-xl font-bold text-slate-900"
                                                        >
                                                            {{ standard.name }}
                                                        </h4>
                                                    </div>
                                                    <p
                                                        class="text-sm leading-7 text-slate-600"
                                                    >
                                                        {{
                                                            standard.description
                                                        }}
                                                    </p>
                                                    <p
                                                        class="text-xs font-semibold text-slate-500"
                                                    >
                                                        {{
                                                            'translate_criterion_weight'
                                                                | translate
                                                        }}:
                                                        {{
                                                            standard.weight ?? 0
                                                        }}
                                                    </p>
                                                </div>
                                                @if (
                                                    record.selectedRubricLevelName
                                                ) {
                                                    <div
                                                        class="rounded-2xl px-4 py-3 text-white"
                                                        [style.background]="
                                                            record.selectedRubricLevelColor ||
                                                            '#0f766e'
                                                        "
                                                    >
                                                        <div
                                                            class="text-xs text-white/75"
                                                        >
                                                            {{
                                                                'translate_selected_level'
                                                                    | translate
                                                            }}
                                                        </div>
                                                        <div
                                                            class="mt-1 text-base font-bold"
                                                        >
                                                            {{
                                                                record.selectedRubricLevelName
                                                            }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div
                                                class="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-5"
                                            >
                                                @for (
                                                    level of standard.rubricLevels;
                                                    track trackByIndex(
                                                        $index,
                                                        level
                                                    )
                                                ) {
                                                    <button
                                                        type="button"
                                                        (click)="
                                                            selectLevel(
                                                                record,
                                                                standard,
                                                                level
                                                            )
                                                        "
                                                        class="rounded-[22px] border p-4 text-start transition"
                                                        [ngClass]="
                                                            isSelectedLevel(
                                                                record,
                                                                level
                                                            )
                                                                ? 'border-transparent shadow-[0_18px_40px_-28px_rgba(15,23,42,0.65)]'
                                                                : 'border-slate-200 bg-white hover:border-teal-300'
                                                        "
                                                        [style.background]="
                                                            isSelectedLevel(
                                                                record,
                                                                level
                                                            )
                                                                ? level.color
                                                                : null
                                                        "
                                                        [style.color]="
                                                            isSelectedLevel(
                                                                record,
                                                                level
                                                            )
                                                                ? '#ffffff'
                                                                : null
                                                        "
                                                        [disabled]="
                                                            mode === 'view'
                                                        "
                                                    >
                                                        <div
                                                            class="text-sm font-bold"
                                                        >
                                                            {{
                                                                level.rubricLevelName
                                                            }}
                                                        </div>
                                                        <div
                                                            class="mt-2 text-xs font-semibold"
                                                            [ngClass]="
                                                                isSelectedLevel(
                                                                    record,
                                                                    level
                                                                )
                                                                    ? 'text-white/75'
                                                                    : 'text-slate-500'
                                                            "
                                                        >
                                                            {{
                                                                level.from ?? 0
                                                            }}
                                                            -
                                                            {{ level.to ?? 0 }}
                                                        </div>
                                                        <p
                                                            class="mt-3 text-sm leading-6"
                                                            [ngClass]="
                                                                isSelectedLevel(
                                                                    record,
                                                                    level
                                                                )
                                                                    ? 'text-white/90'
                                                                    : 'text-slate-600'
                                                            "
                                                        >
                                                            {{
                                                                level.description
                                                            }}
                                                        </p>
                                                    </button>
                                                }
                                            </div>
                                            <div
                                                class="mt-4 grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)]"
                                            >
                                                <div>
                                                    <label
                                                        class="mb-2 block text-sm font-semibold text-slate-700"
                                                    >
                                                        {{
                                                            'translate_criterion_assessment_value'
                                                                | translate
                                                        }}
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        class="hide-arrows w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-center text-lg font-bold text-slate-900"
                                                        [disabled]="
                                                            mode === 'view' ||
                                                            !record.selectedRubricLevelId
                                                        "
                                                        [ngModel]="record.value"
                                                        (ngModelChange)="
                                                            record.value =
                                                                $event;
                                                            checkForEmptyValues()
                                                        "
                                                    />
                                                    @if (
                                                        !record.selectedRubricLevelId
                                                    ) {
                                                        <p
                                                            class="mt-2 text-xs text-amber-600"
                                                        >
                                                            {{
                                                                'translate_choose_a_level_first'
                                                                    | translate
                                                            }}
                                                        </p>
                                                    }
                                                    @if (
                                                        isValueOutOfRange(
                                                            record,
                                                            standard
                                                        )
                                                    ) {
                                                        <p
                                                            class="mt-2 text-xs text-rose-600"
                                                        >
                                                            {{
                                                                'translate_evaluation_value_must_be_within_selected_level_range'
                                                                    | translate
                                                            }}
                                                        </p>
                                                    }
                                                </div>
                                                @if (!hideNotes) {
                                                    <div>
                                                        <label
                                                            class="mb-2 block text-sm font-semibold text-slate-700"
                                                        >
                                                            {{
                                                                'translate_notes'
                                                                    | translate
                                                            }}
                                                        </label>
                                                        <textarea
                                                            class="min-h-[108px] w-full rounded-2xl border border-slate-200 bg-white px-4 py-3"
                                                            [disabled]="
                                                                mode === 'view'
                                                            "
                                                            [(ngModel)]="
                                                                record.note
                                                            "
                                                        ></textarea>
                                                    </div>
                                                }
                                            </div>
                                        </section>
                                    }
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </app-list-loading>
    }
    @if (!hideNotes) {
        <div class="flex flex-col gap-1">
            <label class="text-sm font-semibold text-slate-700">
                {{ 'translate_recommendations' | translate }}
            </label>
            <textarea
                *appWaitUntilLoaded="item"
                [disabled]="mode === 'view'"
                [(ngModel)]="item.note"
                class="min-h-[120px] rounded-[24px] border border-slate-200 bg-white px-4 py-3"
            ></textarea>
        </div>
    }

    <div class="flex flex-row justify-center gap-4">
        @if (
            mode !== 'view' &&
            (selectedEvaluation || itemId) &&
            !hasNoEvaluationDefinition &&
            item?.records?.length
        ) {
            <button
                (click)="processUpdate()"
                [disabled]="isSubmitting || hasEmptyValue || hasValueOutOfRange"
                class="btn btn-primary flex flex-row items-center gap-2 self-center"
            >
                @if (isSubmitting) {
                    <app-loading-ring></app-loading-ring>
                }
                <i class="fa-light fa-save"></i>
                <span>{{ 'translate_save' | translate }}</span>
            </button>
        }

        <ng-container
            [ngTemplateOutlet]="
                $safeNavigationMigration(customAction?.template)
            "
            [ngTemplateOutletContext]="{
                item: $safeNavigationMigration(customAction?.item),
            }"
        ></ng-container>
    </div>
</div>
